import {
    DropdownItem, ExcludableTextbox, LookupModelSearchEvent, Textbox
} from "@mcleod/components";
import { getDispatchControlBoolean } from "@mcleod/general";
import { AutogenLayoutCustomerRevenueReport } from "./autogen/AutogenLayoutCustomerRevenueReport";

export class CustomerRevenueReport extends AutogenLayoutCustomerRevenueReport {
    _containerEnabled: boolean;

    override onLoad(): void | Promise<void> {
        // Toggle container-module related controls
        this._containerEnabled = getDispatchControlBoolean("is_container_active", false);
        this.toggleContainerEnabled(this._containerEnabled);

        // Initialize form defaults
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxInclude.selectedItem = this.textboxInclude.items[0];
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxOutboundFrom.selectedItem = this.textboxOutboundFrom.items[0];
        this.textboxInboundTo.selectedItem = this.textboxInboundTo.items[0];
    }

    private toggleContainerEnabled(isEnabled: boolean) {
        this.excludabletextboxContainerssLocationId.enabled = isEnabled;
        this.excludabletextboxContainerssLocationId.visible = isEnabled;
        this.textboxInclude.enabled = isEnabled;
        this.textboxInclude.visible = isEnabled;
    }

    private textboxSteamshipLinesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_steamship = "Y"
    }

    private onChangeOutboundFrom(event: EventListener) {
        this.excludabletextboxOutbound.textbox.clear();
        if (this.textboxOutboundFrom.selectedItem?.displayValue !== "None") {
            this.excludabletextboxOutbound.enabled = true;
            this.excludabletextboxOutbound.visible = true;
            const selectedItem = this.textboxOutboundFrom.selectedItem;
            this.setupInboundOutboundLookup(selectedItem, this.excludabletextboxOutbound, "Outbound From ");
        } else {
            this.excludabletextboxOutbound.visible = false;
        }
    }

    private onChangeInboundTo() {
        this.excludabletextboxInbound.textbox.clear();
        if (this.textboxInboundTo.selectedItem?.displayValue !== "None") {
            this.excludabletextboxInbound.enabled = true;
            this.excludabletextboxInbound.visible = true;
            const selectedItem = this.textboxInboundTo.selectedItem;
            this.setupInboundOutboundLookup(selectedItem, this.excludabletextboxInbound, "Inbound To ");
        } else {
            this.excludabletextboxInbound.visible = false;
        }
    }

    private setupInboundOutboundLookup(selectedItem: DropdownItem, textboxLookup: ExcludableTextbox, captionDescription: string) {
        if(selectedItem) {
            switch (selectedItem.value) {
                case "L":
                    textboxLookup.textbox.caption = captionDescription + "(Location)";
                    textboxLookup.textbox.lookupModel = "lme/dispatch/location";
                    textboxLookup.textbox.lookupModelLayout = "lme/dispatch/LocationLookup";
                    textboxLookup.textbox.lookupModelDisplayField = "name";
                    textboxLookup.textbox.lookupModelResultField = "id";
                    textboxLookup.textbox.lookupModelAllowMultiSelect = true;
                    break;
                case "S":
                    textboxLookup.textbox.caption = captionDescription + "(State)";
                    textboxLookup.textbox.lookupModel = "common/states";
                    textboxLookup.textbox.lookupModelLayout = "common/States";
                    textboxLookup.textbox.lookupModelDisplayField = "name";
                    textboxLookup.textbox.lookupModelResultField = "id";
                    textboxLookup.textbox.lookupModelAllowMultiSelect = true;
                    break;
                case "Z":
                    textboxLookup.textbox.caption = captionDescription + "(Zone)";
                    textboxLookup.textbox.lookupModel = "lme/general/zones";
                    textboxLookup.textbox.lookupModelLayout = "lme/general/Zones";
                    textboxLookup.textbox.lookupModelDisplayField = "descr";
                    textboxLookup.textbox.lookupModelResultField = "id";
                    textboxLookup.textbox.lookupModelAllowMultiSelect = true;
                    break;
                case "P":
                    textboxLookup.textbox.lookupModel = null;
                    textboxLookup.textbox.lookupModelLayout = null;
                    textboxLookup.textbox.lookupModelDisplayField = null;
                    textboxLookup.textbox.lookupModelResultField = null;
                    textboxLookup.textbox.caption = captionDescription + "(Zip)";
                    textboxLookup.textbox.text = this.makeFauxLookupModelValue(textboxLookup.textbox.text)
            }
        }
    }

    private onChangeInclude() {
        if (this.textboxInclude.selectedItem && this.textboxInclude.selectedItem.value === "N") {
            this.excludabletextboxContainerssLocationId.enabled = false;
            this.excludabletextboxContainerssLocationId.textbox.clear();
        } else {
            this.excludabletextboxContainerssLocationId.enabled = true;
        }
    }

    private isZipCodeValid(textbox: Textbox): boolean {
        textbox.resetValidation();
        const valid = /^[0-9,\s]*$/.test(textbox.text.trim());
        if (!valid) {
            textbox.validationWarning = "Invalid zip code format";
            textbox.focus();
        }
        return valid;
    }

    private makeFauxLookupModelValue(value: string): string {
        // Remove any characters that are not numbers or commas
        const cleanedValue = value.replace(/[^0-9,]/g, '');

        // Prepend "in " if there are multiple items
        const items = cleanedValue.split(',').filter(item => item.trim() !== '');
        return items.length > 1 ? `in ${items.join(',')}` : cleanedValue;
    }

    private isUserInputValid(): boolean {
        if (this.textboxOutboundFrom.selectedItem.value === "P") {
            if (!this.isZipCodeValid(this.excludabletextboxOutbound.textbox)) return false;
        }
        if (this.textboxInboundTo.selectedItem.value === "P") {
            if (!this.isZipCodeValid(this.excludabletextboxInbound.textbox)) return false;
        }
        return true;
    }
}
